import { createFileRoute } from "@tanstack/react-router";
import { useTranslation } from "react-i18next";
import { assertPagePermission } from "@/features/auth/lib/assert-page-permission";
import { pageStateQueryOptions, PageAccessError } from "@/lib/queries";
import { PageError } from "@/features/auth/components/PageError";
import { usePageState } from "@/hooks/usePageState";
import { useDocumentTitle } from "@/hooks/useDocumentTitle";
import { MarketplaceAdminPage } from "@/features/marketplace/admin/pages/MarketplaceAdminPage";

function MarketplaceAdminRoute() {
  const { t } = useTranslation();
  useDocumentTitle(t("marketplace.admin.title", "Vendor Catalog"));

  const { isLoading, error } = usePageState("marketplace.admin");

  if (isLoading) return null;
  if (error) return <PageError is403={error instanceof PageAccessError} />;
  return <MarketplaceAdminPage />;
}

export const Route = createFileRoute("/_authenticated/marketplace/admin")({
  beforeLoad: () => assertPagePermission("marketplace.admin"),
  loader: ({ context }) =>
    context.queryClient
      .ensureQueryData(pageStateQueryOptions("marketplace.admin"))
      .catch((err: unknown) => {
        if (err instanceof PageAccessError) return null;
        throw err;
      }),
  component: MarketplaceAdminRoute,
  errorComponent: ({ error }) => (
    <PageError is403={error instanceof PageAccessError} />
  ),
});
